import React, { useState, useEffect } from 'react';
import './ResignListEmployees.css';

const ResignListEmployees = () => {
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchResignations = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/resignations/approved`);
        if (!response.ok) throw new Error('Failed to fetch resignations');
        const data = await response.json();
         // Add flag to track email state only for approved ones
        const employeesWithFlag = data.map((emp) => ({
          ...emp,
          emailSent: emp.resignationStatus === "DONE", // Already done means button hidden
        }));
        setEmployees(employeesWithFlag);
      } catch (err) {
        console.error(err);
        setError('Failed to load resignations');
      } finally {
        setLoading(false);
      }
    };

    fetchResignations();
  }, []);
  // ✅ Send Email Function
  const handleSendEmail = async (employeeId) => {
    const payload = {
      name: localStorage.getItem("full_name"),
      role: localStorage.getItem("role"),
      employeeId: localStorage.getItem("employeeId"),
    };

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/api/resignations/sendlink?employeeId=${employeeId}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(payload),
        }
      );

      if (!response.ok) throw new Error('Failed to send email');

        // ✅ Update both flags locally
    const updatedEmployees = employees.map((emp) =>
      emp.employeeId === employeeId
        ? { ...emp, emailSent: true, resignationStatus: "DONE" }
        : emp
    );


      setEmployees(updatedEmployees);
      alert('Email sent successfully!');
    } catch (err) {
      console.error(err);
      alert('Failed to send email. Please try again.');
    }
  };
  if (loading) {
    return <div className="resign-main-div">Loading resignations...</div>;
  }

  if (error) {
    return <div className="resign-main-div">{error}</div>;
  }


  return (
    <div className="resign-main-div">
      <div className="resign-employee-list">
        <h2>Resign List Employees</h2>
        <div className="resign-table">
          <div className="resign-mid-report">
            <table className="resign-report">
              <thead>
                <tr>
                  <th>S.No</th>
                  <th>Employee Name</th>
                  <th>Designation</th>
                  <th>Client</th>
                  <th>Project</th>
                  <th>Relieving Date</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {employees.length > 0 ? (
                  employees.map((emp, index) => (
                    <tr key={emp.id}>
                      <td>{index + 1}</td>
                      <td>{emp.employeeName || 'N/A'}</td>
                      <td>{emp.designation || 'N/A'}</td>
                      <td>{emp.client || 'N/A'}</td>
                      <td>{emp.project || 'N/A'}</td>
                      <td>{emp.lastDate || 'N/A'}</td>
                      <td>
                        {emp.emailSent ? (
                          <span
                            style={{
                              color:
                                emp.resignationStatus === "DONE"
                                  ? "green"
                                  : "red",
                              fontWeight: "bold",
                            }}
                          >
                            {emp.resignationStatus}
                          </span>
                        ) : (
                          <button
                            className="action-btn"
                            onClick={() => handleSendEmail(emp.employeeId)}
                          >
                            Send
                          </button>
                        )}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="7" style={{ textAlign: 'center' }}>
                      No resigned employees found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResignListEmployees;
